import React, {useState} from 'react'
import {Row, Col, Modal, ModalBody, Input} from "reactstrap";

// labels
import {CONTINUE, LB_CONTINUE_WITH_OUT_CONFIRMATION_NUMBER, LB_HAVE_CONFIRMATION_NUMBER} from "../../i18n/i18n";
import {ButtonCancel, ButtonSubmit, CustomButton} from "../../buttons/buttonsActions";
import {PH_SET_CONFIRMATION_NUMBER} from "../../i18n/placeHolders";

const ModalConfirmationCode = props => {
    const { isOpen, handleToggle, setExternalData  } = props

    const [confirmationCode, setConfirmationCode] = useState('')

    const onConfirmationCodeChange = e => setConfirmationCode( e?.target?.value )


    return <Modal
        isOpen={ isOpen }
        centered={ true }
        unmountOnClose={ true }
        onClosed={()=>onConfirmationCodeChange( '' )}
        toggle={ handleToggle }
        className={`wl-modal wl-modal-select-option`}
    >
        <ModalBody className={'wl-modal-body'}>
            <div className={'wl-modal-title'}>
                { LB_HAVE_CONFIRMATION_NUMBER }
            </div>
            <div>
                <Row>
                    <Col sm={{
                        size:6,
                        offset: 3
                    }} className={'mb-2em'}>
                        <Input
                            type='text'
                            value={confirmationCode}
                            placeholder={ PH_SET_CONFIRMATION_NUMBER }
                            onChange={ onConfirmationCodeChange }
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-center">
                        <div>
                            <CustomButton
                                title={ confirmationCode ? CONTINUE : LB_CONTINUE_WITH_OUT_CONFIRMATION_NUMBER }
                                onClick={ () => setExternalData(confirmationCode)}
                            />
                            <ButtonCancel onClick={ handleToggle }/>
                        </div>
                    </Col>
                </Row>
            </div>
        </ModalBody>
    </Modal>
}

export default ModalConfirmationCode

